import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";

class ActiveOrdersStore extends EventEmitter {
    constructor() {
        super();
        this.allOrders=[];
        this.filteredOrders=[];
    }
    getAll() {
        return this.allOrders;
    }
    getSingle(id) {

    }
    getFiltered(){
        return this.filteredOrders;
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_ALL_ACTIVE_ORDERS":
            {
                this.filteredOrders=action.activeOrders;
                this.allOrders=action.activeOrders;
                this.emit("change");
                break
            }
            case "FILTER_DATA_BY_DATES":{
                this.emit("change");
                break;
            }
        }



    }

}

const activeOrders = new ActiveOrdersStore;
dispatcher.register(activeOrders.handleActions.bind(activeOrders));

export default activeOrders;



// WEBPACK FOOTER //
// ./src/stores/ActiveOrdersStore.js